<!--
@component
SEOSEO

See markup below.
-->

<script lang="ts">
  import { SEO as SEOComponent } from '@reuters-graphics/graphics-components';
  import getPath from '$utils/getPath';
  import { page } from '$app/state';
  import pkg from '$pkg';

  /**
   * Props the upstream `@reuters-graphics/graphics-components` `SEO` accepts.\
   * This local interface mirrors the upstream
   * shape (see `node_modules/@reuters-graphics/graphics-components/dist/components/SEO/SEO.svelte.d.ts`)
   * for the fields callers of this wrapper need to supply. The wrapper
   * itself fills in `baseUrl`, `pageUrl`, `publishTime`, `updateTime` and
   * `authors` from the project config, and resolves `shareImgPath` against
   * the SvelteKit assets base via `getPath(...)`. All fields are optional
   * so pages can pass partial data
   * (e.g. Mustache-templated strings that may be missing on a given route).
   */
  interface SeoProps {
    seoTitle?: string;
    seoDescription?: string;
    shareTitle?: string;
    shareDescription?: string;
    shareImgPath?: string;
    shareImgAlt?: string;
  }

  let { seo }: { seo: SeoProps } = $props();

  // Pull constants out once so the markup stays readable.
  const graphic = pkg.reuters.graphic;
  const baseUrl = import.meta.env.BASE_URL;

  // Safe URL join: `getPath(...)` handles missing path / stray slashes.
  const shareImgPath = $derived(
    seo.shareImgPath ? getPath(seo.shareImgPath) : ''
  );
</script>

<SEOComponent
  {baseUrl}
  pageUrl={page.url}
  seoTitle={seo.seoTitle ?? ''}
  seoDescription={seo.seoDescription ?? ''}
  shareTitle={seo.shareTitle ?? ''}
  shareDescription={seo.shareDescription ?? ''}
  {shareImgPath}
  shareImgAlt={seo.shareImgAlt ?? ''}
  publishTime={graphic?.published}
  updateTime={graphic?.updated}
  authors={graphic?.authors}
/>
